// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/global","css/example-page"], () => (__webpack_require__("./src/js/global.js")))
__webpack_require__.O(undefined, ["css/global","css/example-page"], () => (__webpack_require__("./src/sass/global.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/global","css/example-page"], () => (__webpack_require__("./src/sass/example-page.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
